import React from 'react';
import ColorPalette from '../../colorpalette/ColorPalette';

/**
 * PublicPrivacyFooter
 *
 * Linha discreta exibida ao final de toda página pública voltada ao
 * paciente (confirmação de agendamento, agenda online, pesquisa de
 * satisfação) linkando para a Política de Privacidade (LGPD).
 *
 * Usa estilo inline para funcionar em qualquer layout público, sem
 * depender do CSS específico de cada página.
 */
function PublicPrivacyFooter() {
  return (
    <p
      style={{
        textAlign: 'center',
        fontSize: 12,
        color: ColorPalette.textLight,
        margin: '16px 0 4px',
        padding: '0 16px',
      }}
    >
      Seus dados são tratados conforme a{' '}
      <a
        href="/terms-privacy"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: ColorPalette.textMedium, textDecoration: 'underline' }}
      >
        Política de privacidade
      </a>
      {' '}da Gabriela.
    </p>
  );
}

export default PublicPrivacyFooter;
